module.exports = __webpack_public_path__ + "img/4_150.5622fcf3.png";